import styled from 'styled-components/macro'
import { prop } from 'styled-tools'

import { CertificateState as CertificateStateEnum } from 'src/types/graphql'

const Chip = styled.div<{ backgroundColor?: string }>`
    padding: ${({ theme }) => theme.spacing(0.5)} ${({ theme }) => theme.spacing(1.5)};
    background: ${prop('backgroundColor')};
    border-radius: ${({ theme }) => theme.spacing(1)};
    border: 1px solid #ccc;
    width: 15em;

    text-align: center;
`

interface CertificateStateProps {
    state: CertificateStateEnum
}

export function CertificateState({ state }: CertificateStateProps) {
    return <Chip backgroundColor={getCertificateStateBackgroundColor(state)}>{getCertificateStateName(state)}</Chip>
}

export function getCertificateStateBackgroundColor(state: CertificateStateEnum) {
    switch (state) {
        case CertificateStateEnum.Pending:
            return '#fff'
        case CertificateStateEnum.InProgress:
            return '#F1C40F'
        case CertificateStateEnum.Passed:
            return '#2ecc71'
        case CertificateStateEnum.Failed:
            return '#e74c3c'
    }
}

export function getCertificateStateName(state: CertificateStateEnum) {
    switch (state) {
        case CertificateStateEnum.Pending:
            return 'Ausstehend'
        case CertificateStateEnum.InProgress:
            return 'Test wird absolviert'
        case CertificateStateEnum.Passed:
            return 'Bestanden'
        case CertificateStateEnum.Failed:
            return 'Nicht Bestanden'
    }
}
